import styled from 'styled-components';

export const Main = styled.div`
display:flex;
flex-flow: column wrap;
gap:20px;
padding:40px;


`